import {inject, injectable} from "inversify";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";

export interface IPositionResponse {
	position: number;
	squadId: number;
}

export interface IConferencesResponse {
	conferenceId: number;
	positions: IPositionResponse[];
}

export interface IPlayoffPicture {
	conferences: IConferencesResponse[];
}

export interface IPredictionResponse {
	playoffPicture: IPlayoffPicture | null;
	updatedAt: string | null;
}

export interface IPredictionPayload {
	playoffPicture: IPlayoffPicture | null;
}

type TPredictionResponse = IApiResponse<IPredictionResponse>;
type TPredictionImageResponse = IApiResponse<{fileName: string}>;

export interface IPredictionApiProvider {
	get_prediction: () => Promise<AxiosResponse<TPredictionResponse>>;
	save_prediction: (payload: IPredictionPayload) => Promise<AxiosResponse<TPredictionResponse>>;
	get_prediction_image: () => Promise<AxiosResponse<TPredictionImageResponse>>;
}

@injectable()
export class PredictionApiProvider implements IPredictionApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	get_prediction = () => this._http.get<TPredictionResponse>("prediction");
	save_prediction = (payload: IPredictionPayload) =>
		this._http.post<TPredictionResponse>("prediction", payload);
	get_prediction_image = () => this._http.get<TPredictionImageResponse>("prediction/image");
}
